"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
exports.view = {
    text: 'Click here to read more about our products and offers!',
    isDisplayDirectly: true,
    url: 'https://www.flarie.com',
    backgroundImage: '',
    componentStyle: {
        color: 'ffffff',
        backgroundColor: '000000',
        position: 'absolute',
        textAlign: 'center',
        fontSize: '20px',
        top: '20%',
    },
};
